// Temporary stub for @react-pdf/renderer
export const pdf = (element?: any) => ({ toBlob: async () => new Blob(), updateContainer: (doc: any) => {} });
export const Document = (props: any) => null;
export const Page = (props: any) => null;
export const View = (props: any) => null;
export const Text = (props: any) => null;
export const StyleSheet = { create: (styles: any) => styles };
export const Font = { register: (config: any) => {} };
